// This file is automatically generated. Do not edit manually.

import { ShopOrderLineReservationRequestService_ReservationRequest } from "src/api/generated/erp/production/service/shopOrderLine/shopOrderLineReservationRequestService";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ShopOrderBomReservationFormApi {
	export async function createReservations(args: {
		reservationRequests: Array<ShopOrderLineReservationRequestService_ReservationRequest>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderBomReservationForm/createReservations",
			method: "POST",
			data: {
				reservationRequests: args.reservationRequests,
			},
		});
		return response as void;
	}
}
